"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreloadDataService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var PreloadDataService = /** @class */ (function () {
    function PreloadDataService() {
    }
    /**
     * Remember that it's a underground preload mechanism and aiming for improving
     * the performance, it should only be used in bundle and seismic-common.
     * In another word, you should never use it in your feature repos.
     * @returns IAppData | undefined
     */
    PreloadDataService.prototype.getPreloadData = function () {
        return window.appDatas;
    };
    PreloadDataService = __decorate([
        CommonService_decorator_1.CommonService('PreloadDataService')
    ], PreloadDataService);
    return PreloadDataService;
}());
exports.PreloadDataService = PreloadDataService;
//# sourceMappingURL=PreloadData.service.js.map